/**
 * @generated SignedSource<<4761c05886bb8319d8c0f47f0c5ae7c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsHeaderFragment_facility$data = {
  readonly club: {
    readonly logoImage: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedFiltersModalFragment_facility" | "LessonsFiltersModalFragment_facility" | "useFacilityLessonNoun_facility" | "useGetLessonAgendaFilterBar_facility">;
  readonly " $fragmentType": "LessonsHeaderFragment_facility";
};
export type LessonsHeaderFragment_facility$key = {
  readonly " $data"?: LessonsHeaderFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsHeaderFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsHeaderFragment_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonNoun_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLessonAgendaFilterBar_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationBasedFiltersModalFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonsFiltersModalFragment_facility"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "logoImage",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FacilityLogoFragment_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "ee6338a5fe76850337dce2501d7441f3";

export default node;
